module.exports = __webpack_public_path__ + "static/softball-clubhouse-makeover-2c1193ec52b3f18f2c34fc8ab22d8abd.jpg";